import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CorrAxesTable = ({
  rowData,
  index,
 }) => {
  return (
    <div
      style={index % 2 !== 0 ? { background: 'rgba(145, 162, 185, 0.2)' } : { background: 'transparent' }}
      className="generic-sht-row-content"
      data-test="corrAxesTableComponent"
    >
      <Fragment>
        <div data-test="corrAxesCellContentComponent" className="generic-sht-cell-item">
          <div
            className='generic-sht-cell-item-value'
          >{`${rowData.axis}`}
          </div>
        </div>
        <div data-test="corrAxesCellContentComponent" className="generic-sht-cell-item">
          <div
            className='generic-sht-cell-item-value'
          >
            {`${rowData.eigenValue}`}
          </div>
        </div>
        <div data-test="corrAxesCellContentComponent" className="generic-sht-cell-item">
          <div
            className='generic-sht-cell-item-value'
          >
            {`${rowData.cumeEigenValues}`}
          </div>
        </div>
        <div data-test="corrAxesCellContentComponent" className="generic-sht-cell-item">
          <div
            className='generic-sht-cell-item-value'
          >
            {`${rowData.varianceExplainedValues}%`}
          </div>
        </div>
        <div data-test="corrAxesCellContentComponent" className="generic-sht-cell-item">
          <div
            className='generic-sht-cell-item-value'
          >
            {`${rowData.cumeVarianceExplainedValues}%`}
          </div>
        </div>
      </Fragment>
    </div>
  );
};

CorrAxesTable.propTypes = {
  rowData: PropTypes.instanceOf(Object),
  index: PropTypes.number,
};

export default CorrAxesTable;
